import { api, API_URL } from "../config/apiConfig";
import { handleUnauthorizedOrForbidden } from "../config/varConfig";

export const getReferralBonusHistory = async (params = {}) => {
  try {
    const response = await api.get(
      `${API_URL}/transaction/getReferralBonusHistory`,
      {
        params: {
          page: params.page || 1,
          limit: params.limit || 10,
          search: params.search || "",
          startDate: params.startDate || "",
          endDate: params.endDate || "",
          includeTotal: params.includeTotal ?? false,
        },
      },
    );
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};
